import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';
import { ClaimSums } from 'src/types/claim-sum';

export type InterestClaim = {
  remaining_amount: number | null;
  original_amount: number | null;
};

export type ContractualInterestClaim = {
  remaining_amount: number | null;
  original_amount: number | null;
  rate: string | null;
};

export type PayeeFeeClaim = {
  remaining_amount: number | null;
  original_amount: number | null;
};

export type ProceduralFeeClaim = {
  remaining_amount: number | null;
  original_amount: number | null;
};

export type FlatRateCostClaim = {
  parent: {
    id: string;
    due_date_at: string | null;
    remaining_amount: number;
    original_amount: number;
  };
  flat_rate_cost_claim: {
    remaining_amount: number | null;
    original_amount: number | null;
  };
};

export type GetHiddenClaimsResponse = {
  payee_case: {
    principal_claims_sums: ClaimSums,
  };
  interest_claim_added: boolean;
  payee_fee_claim_added: boolean;
  procedural_fee_claim_added: boolean;
  flat_rate_cost_claims_added: boolean;
  payee_fee_claim: PayeeFeeClaim;
  procedural_fee_claim: ProceduralFeeClaim;
};

type UpdateMissingOptionalClaimsParams = {
  interest_claim_added: boolean;
  payee_fee_claim_added: boolean;
  procedural_fee_claim_added: boolean;
  flat_rate_cost_claims_added: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {
  async getAllowedClaimTypes(legalRelationshipId: number): Promise<number[]> {
    const url = environment.baseUrl + `/api/allowed-claim-types/${legalRelationshipId}`;
    const result = await axios.get<number[]>(url);

    return result.data;
  }

  async getHiddenClaims(caseId: string): Promise<GetHiddenClaimsResponse> {
    const url = `${environment.baseUrl}/api/hidden-claims/${caseId}`;
    const result = await axios.get(url);
    return result.data;
  }

  async updateHiddenClaims(caseId: string, params: UpdateMissingOptionalClaimsParams): Promise<void> {
    const url = `${environment.baseUrl}/api/hidden-claims/${caseId}`;
    await axios.post(url, params);
  }
}
